module.exports = __webpack_public_path__ + "static/media/sysName.b0cf4d33.png";